import React, { createContext } from 'react';
import { Api } from '../api';
const DEFAULT_QUERY_FETCH_POLICY = 'cache-and-fetch';
const DEFAULT_QUERY_USE_ERROR_BOUNDARY = false;
const DEFAULT_MUTATION_FETCH_POLICY = 'no-cache';
const defaultApi = new Api();
const DEFAULT_API_CONTEXT = {
    api: defaultApi,
    defaults: {
        useApiQuery: {
            fetchPolicy: DEFAULT_QUERY_FETCH_POLICY,
            useErrorBoundary: DEFAULT_QUERY_USE_ERROR_BOUNDARY
        },
        useApiMutation: {
            fetchPolicy: DEFAULT_MUTATION_FETCH_POLICY
        }
    }
};
export const ApiContext = createContext(DEFAULT_API_CONTEXT);
export const ApiProvider = function ApiProvider(props) {
    var _a, _b, _c, _d, _e, _f;
    return (React.createElement(ApiContext.Provider, { value: {
            api: props.api || DEFAULT_API_CONTEXT.api,
            defaults: {
                useApiQuery: {
                    fetchPolicy: ((_b = (_a = props.defaults) === null || _a === void 0 ? void 0 : _a.useApiQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) ||
                        DEFAULT_API_CONTEXT.defaults.useApiQuery.fetchPolicy,
                    useErrorBoundary: ((_d = (_c = props.defaults) === null || _c === void 0 ? void 0 : _c.useApiQuery) === null || _d === void 0 ? void 0 : _d.useErrorBoundary) ||
                        DEFAULT_API_CONTEXT.defaults.useApiQuery.useErrorBoundary
                },
                useApiMutation: {
                    fetchPolicy: ((_f = (_e = props.defaults) === null || _e === void 0 ? void 0 : _e.useApiMutation) === null || _f === void 0 ? void 0 : _f.fetchPolicy) ||
                        DEFAULT_API_CONTEXT.defaults.useApiMutation.fetchPolicy
                }
            }
        } }, props.children));
};
//# sourceMappingURL=context.js.map